// extracted by mini-css-extract-plugin
module.exports = {"wrap":"yf","title":"zf"};